import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    connect() {
        this.validate();
    }
    validate() {
        const groups = [
            ...new Set(this.radioTargets.map((r) => r.dataset.machineSelectionGroup)),
        ];
        const allSelected = groups.every((group) => this.radioTargets.some((r) => r.dataset.machineSelectionGroup === group && r.checked));
        this.submitTarget.disabled = !allSelected;
    }
}
default_1.targets = ["radio", "submit"];
export default default_1;
